import { PendingSubscriptionEvent } from "../../../../../types"
import { LinkBtn } from "../../../buttons"

interface Props {
  event: PendingSubscriptionEvent
  onOpenEmail: (emailId: string) => void
}

const Summary = ({ event, onOpenEmail }: Props) => {
  const { event_type } = event

  const handleOpenEmail = () => {
    console.log("open email")
    if (event.details.email_id) {
      onOpenEmail(event.details.email_id)
    }
  }

  switch (event_type) {
    case "pending_subscription.lo_alert_email":
      return (
        <>
          Active dream rate.{" "}
          <LinkBtn
            theme="alt"
            text="base"
            className="hover:text-primary-500"
            borderClassName="border-0 border-dashed border-neutral-400 border-b rounded-none"
            paddingOff
            onClick={handleOpenEmail}
          >
            Email notification sent
          </LinkBtn>{" "}
          to loan officer
        </>
      )

    case "pending_subscription.user_alert_email":
      return (
        <>
          Active dream rate.{" "}
          <LinkBtn
            theme="alt"
            text="base"
            className="hover:text-primary-500"
            borderClassName="border-0 border-dashed border-neutral-400 border-b rounded-none"
            paddingOff
            onClick={handleOpenEmail}
          >
            Email notification sent
          </LinkBtn>{" "}
          to lead.
        </>
      )

    default:
      return <></>
  }
}

export default Summary
